<template>
  <div
    class="modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    v-bind:class="{ 'show fade bg-shadow' : visible}"
    :style="visible ? 'display:block;': ''"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body text-center mt-4">
            <span class="material-icons text-danger" style="font-size: 77px"> sentiment_dissatisfied </span>
          <h5 class="modal-title">Ups algo salió mal!</h5>
          <p>{{message}}</p>
        </div>
        <div class="p-3 text-center">
          <span class="btn btn-treid" @click="handleClilickSend">Volver</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "ModalWrongBuy",
  props: {
    visible: Boolean,
    message: String
  },
  methods: {
    handleClilickSend(){
      this.$parent.modalWrongBuy.visible = false;
    }
  }
};
</script>
<style lang="css" scoped>
</style>